import { ContractTypeApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { ContractType } from './types';

export const normalizeContractTypes = (data: ContractTypeApi[]): ContractType[] =>
  data.map((d) => normalizeContractType(d));

export const normalizeContractType = (row: ContractTypeApi): ContractType => {
  return { ...row, uuid: uuidv4() };
};
